export default __webpack_public_path__ + "static/media/ic_emoji.82989fd9.svg";